// eslint-disable-next-line deprecate/import
import NextLink from 'next/link';

import type {
  ComponentProps,
  HTMLAttributes,
  PropsWithChildren,
  Ref} from 'react';
import {
  createElement,
  forwardRef
} from 'react';

import type { Url } from 'url';

import { OneOrMany } from './helpers/OneOrMany';

type LinkProps = Omit<
  HTMLAttributes<HTMLAnchorElement> & ComponentProps<typeof NextLink>,
  'href'
> & {
  href: string | Url;
};

const THIS_APPLICATION_BASE_URL = [
  process.env['NEXT_PUBLIC_API_HOST'],
  process.env['NEXT_PUBLIC_BASE_PATH'],
].join('/');

const Link = forwardRef(
  ({ children, ...props }: PropsWithChildren<LinkProps>, ref: Ref<HTMLAnchorElement>) => {
    const href = props.href.toString();

    const component =
      href?.startsWith(THIS_APPLICATION_BASE_URL) || href.startsWith('/') ? NextLink : 'a';

    return createElement(component, { ...props, ref }, ...OneOrMany.asArray(children));
  },
);

export { Link };
